import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { IComponentDef } from '../../../shared/interfaces';
@Component({
  selector: '[r-widget-form-item],r-widget-form-item',
  templateUrl: './r-widget-form-item.component.html',
  styles: [],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class RWidgetFormItemComponent {
  @Input() item: IComponentDef;

  constructor() {}

  getComponent(widget: string) {
    if (!widget) {
      return '';
    }

    if (widget.startsWith('d-')) {
      return `r-${widget}`;
    }

    return `r-d-${widget}`;
  }
}
